import { enumToOptions } from "../../common/enum/util";

export enum MadoVatCodeLineEntryTypeEnum {
    ORIGINAL = 'original',
    REFUND = 'refund',
}

export const madoVatCodeLineEntryTypeOptions = enumToOptions(MadoVatCodeLineEntryTypeEnum, 'organization-settings.mado.vatCodeLine.entryType.');
